/**
 * Created by mac on 12/23/20
 */

const CollectibleView = function (collectible, unitView) {
    this.collectible = collectible;
    this.unitView = unitView;
};

CollectibleView.prototype.collectionAnimation = function (index, callback) {
    let target;

    if (target) {
        target = cleverapps.aims.getTarget(target);
    }

    const actions = [];

    actions.push(new cc.Show());
    actions.push(StandartAnimations.animateCollect(this.unitView, target, {
        path: true,
        adjustToTarget: true,
        collectEffect: true
    }));

    actions.push(new cc.Hide());
    actions.push(new cc.CallFunc(callback));
    actions.push(new cc.RemoveSelf());

    this.unitView.stopAllActions();
    this.unitView.runAction(new cc.Sequence(actions));
};
